export default __webpack_public_path__ + "static/media/splash_glitch.7704aebf.mp4";